import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
    selector: 'app-no-access',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CardModule, ButtonModule],
    templateUrl: './no-access.component.html',
    styles: ``
})
export class NoAccessComponent {

}
